<template>
  <div class="search-results" :class="`search-results--${tileViewMode}-view`">
    <CardAdResults
      :results="results"
      :tile-view-mode="tileViewMode"
    ></CardAdResults>
    <div v-if="results.length === 0" class="search-results__no-result-caption">
      <p>Ingen resultater blev fundet</p>
    </div>
    <div class="search-results__bottom-bar"></div>
    <ProgressBar
      :number-of-results="numberOfResults"
      :current-number-of-results="results.length"
      :search-type="'annoncer'"
    ></ProgressBar>
    <button
      v-if="results.length < numberOfResults"
      @click.prevent="loadResults"
      class="search-results__button button button--highlight"
    >
      Hent flere
    </button>
  </div>
</template>

<script>
import CardAdResults from '@components/CardAdResults/CardAdResults.vue'
import ProgressBar from '@search/ProgressBar/ProgressBar.vue'

export default {
  components: {
    ProgressBar,
    CardAdResults,
  },
  props: {
    results: {
      default: () => {
        return []
      },
      type: Array,
    },
    numberOfResults: { default: null, type: Number },
    tileViewMode: { default: 'default', type: String },
    sort: { default: null, type: String },
    eventBus: { default: null, type: Object },
  },
  methods: {
    loadResults() {
      if (this.results.length === this.numberOfResults) return
      this.eventBus.emit('loadMore-callback')
    },
  },
}
</script>

<style lang="scss">
@import 'SearchResults.scss';
</style>
